import { useNavigate } from "react-router-dom";
import { FiStar } from "react-icons/fi";
import ImageWithPlaceholder from "./ImageWithPlaceholder";

export default function ContentCard({ item, type, fromWatchlist, fillWidth }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/details/${type || item.type}/${fromWatchlist ? item.watchlist_id : item.id}`, {
      state: fromWatchlist ? { is_watchlist: true } : undefined,
    });
  };

  // Support both your API field names and fallbacks
  const poster = item.image || item.poster_url || item.poster;
  const title = item.title || item.name;
  const genre = item.genres || item.genre;

  return (
    <div
      onClick={handleClick}
      className={`group flex-shrink-0 cursor-pointer transition-transform duration-300 hover:scale-105 hover:z-10 ${fillWidth ? "w-full" : "w-[160px] sm:w-[180px] md:w-[200px]"
        }`}
    >
      <div className="relative rounded-lg overflow-hidden aspect-[2/3] bg-dark-700">
        <ImageWithPlaceholder
          src={poster}
          alt={title}
          className="w-full h-full object-cover"
          iconSize={28}
        />

        {/* Badge */}
        {item.badge && (
          <span className="absolute top-2 left-2 bg-primary px-2 py-0.5 rounded text-[0.65rem] font-bold uppercase">
            {item.badge}
          </span>
        )}

        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-3">
          <h4 className="text-sm font-semibold text-white truncate">{title}</h4>
          <div className="flex items-center gap-2 mt-1">
            {item.rating && (
              <span className="flex items-center gap-1 text-xs text-accent">
                <FiStar size={11} /> {item.rating}
              </span>
            )}
            {item.year && <span className="text-xs text-gray-400">{item.year}</span>}
            {genre && <span className="text-xs text-gray-500">{genre}</span>}
          </div>
        </div>
      </div>

      {/* Title below card */}
      <h4 className="mt-2 text-sm text-gray-300 truncate group-hover:text-white transition-colors">
        {title}
      </h4>
    </div>
  );
}
